import React from 'react';

var ClickableImage = function ClickableImage(_ref) {
  var index = _ref.index,
      image = _ref.image,
      labelClass = _ref.labelClass,
      removeExample = _ref.removeExample;
  return /*#__PURE__*/React.createElement("span", {
    className: "label-class__image",
    onClick: function onClick() {
      return removeExample(index);
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "data:image/png;base64, ".concat(image),
    alt: "snapshot for class id ".concat(labelClass.id)
  }));
};

export default ClickableImage;